// @flow
import type {
  FertilizerOperation,
} from '../types'

export default ({
  operations: [],
}: {
  operations: Array<FertilizerOperation>,
})
